import React, { useEffect, useState, useRef } from 'react';
import { supabase } from './supabaseClient';

export default function NubbiHunt() {
  const [hunt, setHunt] = useState(null);
  const [message, setMessage] = useState('');
  const imageRef = useRef(null);

  useEffect(() => {
    const fetchHunt = async () => {
      const { data, error } = await supabase
        .from('nubbi_hunt')
        .select('*')
        .eq('activo', true)
        .order('created_at', { ascending: false })
        .limit(1)
        .maybeSingle();
      if (error) console.error('Error fetching hunt:', error);
      else setHunt(data);
    };
    fetchHunt();
  }, []);

  const handleClick = (e) => {
    if (!hunt || !imageRef.current) return;

    const rect = imageRef.current.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const clickY = e.clientY - rect.top;
    const scaleX = imageRef.current.naturalWidth / rect.width;
    const scaleY = imageRef.current.naturalHeight / rect.height;
    const realX = Math.round(clickX * scaleX);
    const realY = Math.round(clickY * scaleY);

    const dx = realX - hunt.target_x;
    const dy = realY - hunt.target_y;
    const distance = Math.sqrt(dx * dx + dy * dy);

    if (distance <= hunt.radio) {
      setMessage('🎉 You found the Nubbi!');
    } else {
      setMessage('❌ Try again...');
    }
  };

  if (!hunt) return <div style={{ padding: '2rem' }}>Loading hunt...</div>;

  return (
    <div style={{ padding: '1rem', textAlign: 'center' }}>
      <h2>🕵️ NubbiHunt</h2>
      <p>{hunt.titulo}</p>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <img
          ref={imageRef}
          src={hunt.imagen_url}
          alt="Nubbi Hunt Scene"
          onClick={handleClick}
          style={{ width: '100%', height: 'auto', border: '4px solid #333', borderRadius: '12px', cursor: 'crosshair' }}
        />
      </div>
      {message && <h3 style={{ marginTop: '1rem' }}>{message}</h3>}
    </div>
  );
}